module.exports = __webpack_public_path__ + "04_glasses_black.8815622e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer4/04_glasses_black.png
// module id = RABj
// module chunks = 0